import Campaign from '../../areas/campaign';

export default ({ hrefLang, data: { campaign } }, { t }) => {
  // If it's an inactive gift guide we're sending a 404 to the user
  // and obviously don't want to add the gift guide meta tags
  if (Campaign.isGiftGuide(campaign) && !Campaign.isActive(campaign)) {
    return {
      title: t('meta', 'landing.title'),
    };
  }

  const title = campaign ? campaign.title.long : t('campaigns', 'themes.title');
  const description = campaign
    ? campaign.description.long
    : t('campaigns', 'themes.description');
  const campaignLogoBanner =
    campaign && campaign.banners && campaign.banners.length > 0
      ? campaign.banners.find(
          item => item.type.toUpperCase() === 'BANNER_LOGO_BIG'
        )
      : undefined;
  const campaignImage = campaignLogoBanner
    ? campaignLogoBanner.imageUrl
    : undefined;

  const canonical = campaign ? campaign.web_uri.desktop : undefined; // TODO: Change this in dans branch to responsive!

  const openGraph = campaign && [
    { key: 'title', content: title },
    { key: 'description', content: description },
    { key: 'url', content: canonical },
    campaignImage && { key: 'image', content: campaignImage },
    { key: 'type', content: 'website' },
  ];

  let structuredData;
  if (campaign) {
    structuredData = {
      '@context': 'http://schema.org',
      '@type': 'Thing',
      name: campaign.title.page,
      description: campaign.description.page,
      url: canonical,
    };
    if (campaignImage) {
      structuredData.image = campaignImage;
    }
  }

  return {
    title,
    description,
    canonical,
    openGraph,
    structuredData,
    hrefLang: campaign
      ? campaign.hrefLang
      : Object.keys(hrefLang.campaignMain).map(locale => ({
          locale,
          url: hrefLang.campaignMain[locale],
        })),
  };
};
